import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import AccueilComplet from "./components/AccueilComplet";
import { AuthProvider } from "./contexts/AuthContext";
// 🧪 Wrappers dynamiques pour le pilote
import { generateMetierTestRoutes } from "./routes/metierRoutes";

function AppTest() {
  return (
    <AuthProvider>
      <Header />
      <Routes>
        <Route path="/" element={<AccueilComplet />} />
        {/* 🧪 PILOT: génération automatique de toutes les routes métier suffixe -new */}
        {generateMetierTestRoutes().map(r => (
          <Route key={r.key} path={r.path} element={r.element} />
        ))}
        <Route path="*" element={<div>Page en construction</div>} />
      </Routes>
    </AuthProvider>
  );
}

export default AppTest;